"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthListener = void 0;
const react_1 = require("react");
const constants_1 = require("../utils/constants");
/**
 * To be used in wallet.tria.so
 */
function useAuthListener({ authUrl = 'https://auth.tria.so' }) {
    (0, react_1.useEffect)(() => {
        const listen = (event) => {
            if (event.origin !== authUrl)
                return;
            let eventData;
            try {
                eventData = JSON.parse(event.data);
            }
            catch (err) { }
            if ((eventData === null || eventData === void 0 ? void 0 : eventData.type) == constants_1.eventTypes.accessToken) {
                localStorage.setItem('tria.accessToken', eventData === null || eventData === void 0 ? void 0 : eventData.data);
                console.log('Access token set to wallet local storage');
            }
        };
        window.addEventListener('message', listen);
        return () => {
            window.removeEventListener('message', listen);
        };
    }, []);
}
exports.useAuthListener = useAuthListener;
